import { Component, Input, Output, OnInit, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import CommitteeVote from './committee-vote';
import { Apollo } from 'apollo-angular';
import CommitteeVoteType from './committee-vote-type';
import voteQueries from './graphql/votes';
import { CurrentUserService } from '../../../services/current-user.service';
import { User } from '../../../interfaces/user';
import { Subscription } from 'rxjs';
import moment from 'moment';
import { Mutable } from '../../../types/mutable';
import { UserPermissionsService } from 'src/app/services/user-permissions.service';

@Component({
    selector: 'committee-vote',
    templateUrl: './committee-vote.component.html',
    styleUrls: ['./committee-vote.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CommitteeVoteComponent implements OnInit {
  user: User;
  public permsService: UserPermissionsService;
  private userSub: Subscription;
  @Input('vote') vote?: Mutable<CommitteeVote>;
  @Input('voteType') voteType: CommitteeVoteType;
  @Input('milestone_id') milestone_id: string;
  @Input('project_id') project_id: string;
  @Input() readOnly:boolean;
  @Output('voteChange') voteChange = new EventEmitter<CommitteeVote>();
  constructor(
    private apollo: Apollo,
    private userService: CurrentUserService,
    private permService: UserPermissionsService
  ) {
    this.permsService = permService;
  }

  ngOnInit(): void {
    this.userSub = this.userService.getUser().subscribe((user) => {
      this.user = user;
    });
    this.permsService.getUserPermissions(
      'COMMITTEEVOTETYPE',
      this.voteType.id + ''
    );
    if (!this.vote) {
      this.vote = {
        status: null,
        is_proxy: false,
        __typename: 'CommitteeVote',
      };
    }
  }
  handleClick(newStatus: boolean): void {
    if (this.vote) {
      if (this.vote.status === newStatus) {
        this.vote = { ...this.vote, ...{ status: null } };
      } else {
        this.vote = { ...this.vote, ...{ status: newStatus } };
      }
      let mutation;
      if (!this.vote?.id) {
        mutation = this.createVote();
      } else {
        mutation = this.updateVote();
      }
      let sub = mutation.subscribe(({ data }: any) => {
        if (data.hasOwnProperty('vote')) {
          this.vote = { ...this.vote, ...data.vote } as CommitteeVote;
          this.voteChange.emit(this.vote);
        }
        sub && sub.unsubscribe();
      });
    }
  }
  createVote(): ReturnType<Apollo['mutate']> {
    return this.apollo.mutate({
      mutation: voteQueries.CREATE_VOTE,
      variables: {
        input: {
          committee_vote_type_id: this.voteType.id,
          milestone_id: this.milestone_id,
          project_id: this.project_id,
          status: this.vote?.status,
          user_id: this.user.id,
          is_proxy: this.evaluateProxy()
        },
      },
    });
  }
  updateVote(): ReturnType<Apollo['mutate']> {
    return this.apollo.mutate({
      mutation: voteQueries.UPDATE_VOTE,
      variables: {
        input: {
          status: this.vote?.status,
          committee_vote_type_id: this.voteType.id,
          user_id: this.user.id,
          is_proxy: this.evaluateProxy()
        },
        id: this.vote?.id,
      },
    });
  }
  ngOnDestroy() {
    this.userSub && this.userSub.unsubscribe();
  }

  evaluateProxy(){
    return this.user?.person?.name !== this.voteType.user.person.name
  }
  getAuthorString(): string {
    let authorString = ' ';

    if (this.vote?.user?.person?.name) {
      authorString += this.vote?.user.person.name + ': ';
      let dateString = '';
      if (
        this.vote?.modified !== null &&
        this.vote.created !== this.vote.modified
      ) {
        dateString = moment(this.vote.modified).format('MM/DD/YYYY');
      } else {
        dateString = moment(this.vote.created).format('MM/DD/YYYY');
      }
      authorString += dateString;
    }

    return authorString;
  }
}
